import Vue from 'vue'
import Router from 'vue-router'

import Main from '@/views/Main'
import Salary from '@/views/Salary'
import Interview from '@/views/Interview'
import InterviewDetail from '@/views/InterviewDetail'
import Complete from '@/views/Complete'

const routes = [
    {
        path: '/',
        name: 'Main',
        component: Main,
        meta:{
            className: 'main bg-first'
        }
    },
    {
        path: '/interview',
        name: 'Interview',
        component: Interview,
        meta:{
            title: 'Mülakat Deneyimi Paylaş',
            className: 'interview bg-first'
        }
    },
    {
        path: '/interview-detail/:id',
        name: 'InterviewDetail',
        component: InterviewDetail,
        meta:{
            title: 'Mülakat Deneyimi Paylaş',
            className: 'interview-detail bg-first'
        }
    },
    {
        path: '/salary',
        name: 'Salary',
        component: Salary,
        meta:{
            title: 'Maaş Bilgisi Paylaş',
            className: 'salary bg-first'
        }
    },
    {
        path: '/complete/:type',
        name: 'Complete',
        component: Complete,
        meta:{
            title: 'Teşekkürler',
            className: 'complete bg-second'
        }
    },
    {
        path: '*',
        redirect: '/'
    }
];


Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes,
    scrollBehavior () {
        return { x: 0, y: 0 }
    }
});


router.beforeEach((to, from, next)=>{
    //set route meta params

    //set body class
    let bodyTag = document.getElementsByTagName('BODY')[0];
    bodyTag.className = to.meta.className;

    // set title
    if (to.meta.title) document.title = `${to.meta.title} | İşkolig`

    // next router
    next();
})

//router.afterEach((to, from, next) => {})

export default router
